import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";
import {timestampToDate} from '../../../utils/date';
import {ACTION_MAPPING} from "../../../utils/constants";

const HEADER = ['操作時間', '操作者ID', '操作者姓名', '動作', '表單', '異動資料']

export const useExportAuditLogs = ({
  data,
}) => {
  // export cases detail to excel file
  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = []
    values.push(HEADER)
    for (const row of data){
      values.push([
        new Date(timestampToDate(row.createdAt)).toLocaleString(),
        row.userUid,
        row.userName,
        ACTION_MAPPING[row.action],
        row.collectionName,
        JSON.stringify(row.data)
      ])
    }

    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: '系統編輯紀錄'})
  }
  return { exportData }
}
